// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1 {
  overflow-x: auto;
  overflow-y: auto;
  /* Show header + 20 data rows (~44px each); scroll vertically beyond that. */
  max-height: 924px;
  /* Figma scrollbar theme (Firefox) */
  scrollbar-width: thin;
  scrollbar-color: #8a97a4 transparent;
}

/* Figma scrollbar theme (WebKit / Chromium) */
.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1::-webkit-scrollbar-track {
  background: transparent;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1::-webkit-scrollbar-thumb {
  background-color: #8a97a4;
  border-radius: 6px;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1::-webkit-scrollbar-thumb:hover {
  background-color: #6f7d8c;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1::-webkit-scrollbar-corner {
  background: transparent;
}

/* Keep the column headers visible while the body scrolls. */
.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1 thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #445566;
}

/* Freeze the Alert Type column so it stays visible while the period columns scroll horizontally. */
.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__firstCol--mfa8T {
  position: sticky;
  left: 0;
  z-index: 1;
  text-align: left !important;
  white-space: nowrap;
  min-width: 140px;
  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.3);
}

/* Corner cell needs to stay above both the sticky header row and the sticky column. */
.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1 thead th.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__firstCol--mfa8T {
  z-index: 3;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1 tbody tr:nth-of-type(odd) td.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__firstCol--mfa8T {
  background-color: #eaeaea;
}

.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1 tbody tr:nth-of-type(even) td.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__firstCol--mfa8T {
  background-color: #d3d7da;
}

/* Period column headers (e.g. "Aug", "Sep") — Figma text spec. */
.src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__periodHeader--BCbPA {
  font-family: 'Proxima Nova', sans-serif;
  font-weight: 600;
  text-align: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/alertsByTypeTable.module.css"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4EAA4E;EAC5E,iBAAiB;EACjB,oCAAoC;EACpC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA,mGAAmG;AACnG;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,sFAAsF;AACtF;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,uCAAuC;EACvC,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":["\n\n.scrollArea {\n  overflow-x: auto;\n  overflow-y: auto;\n  /* Show header + 20 data rows (~44px each); scroll vertically beyond that. */\n  max-height: 924px;\n  /* Figma scrollbar theme (Firefox) */\n  scrollbar-width: thin;\n  scrollbar-color: #8a97a4 transparent;\n}\n\n/* Figma scrollbar theme (WebKit / Chromium) */\n.scrollArea::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scrollArea::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollArea::-webkit-scrollbar-thumb {\n  background-color: #8a97a4;\n  border-radius: 6px;\n}\n\n.scrollArea::-webkit-scrollbar-thumb:hover {\n  background-color: #6f7d8c;\n}\n\n.scrollArea::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Keep the column headers visible while the body scrolls. */\n.scrollArea thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #445566;\n}\n\n/* Freeze the Alert Type column so it stays visible while the period columns scroll horizontally. */\n.firstCol {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  text-align: left !important;\n  white-space: nowrap;\n  min-width: 140px;\n  box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.3);\n}\n\n/* Corner cell needs to stay above both the sticky header row and the sticky column. */\n.scrollArea thead th.firstCol {\n  z-index: 3;\n}\n\n.scrollArea tbody tr:nth-of-type(odd) td.firstCol {\n  background-color: #eaeaea;\n}\n\n.scrollArea tbody tr:nth-of-type(even) td.firstCol {\n  background-color: #d3d7da;\n}\n\n/* Period column headers (e.g. \"Aug\", \"Sep\") — Figma text spec. */\n.periodHeader {\n  font-family: 'Proxima Nova', sans-serif;\n  font-weight: 600;\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollArea": `src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__scrollArea--fW1u1`,
	"firstCol": `src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__firstCol--mfa8T`,
	"periodHeader": `src-js-pages-usageReportingContainer-components-alertsByTypeTable-module__periodHeader--BCbPA`
};
export default ___CSS_LOADER_EXPORT___;
